import { render, staticRenderFns } from "./ChallengeCard.vue?vue&type=template&id=285424d7&scoped=true&"
import script from "./ChallengeCard.vue?vue&type=script&lang=js&"
export * from "./ChallengeCard.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeCard.vue?vue&type=style&index=0&id=285424d7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285424d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VHover,VIcon,VImg,VList,VMenu,VRow})
